import React from 'react';

export const RiskInsights = () => {
  return <div>Risk Insights</div>;
};
